import DetailViewContentElement from "../../../common/models/detailView/elements/detailViewContentElement";
import {Hash} from "~/interfaces/hashInterfaces";
import {ObjectHelper} from "~/helpers/objectHelper";
import RelationSectionLinkedDetailView from "~/models/detailView/elements/relationSectionLinkedDetailView";

export class RelationSection extends DetailViewContentElement {
  relation_id: string;
  edit_relation_selected: boolean;
  link_to_view_selected: boolean;
  is_visible_without_record: boolean;
  relation_section_linked_detail_views: Hash<RelationSectionLinkedDetailView> = {};
  get relationSectionLinkedDetailViewsArray(): RelationSectionLinkedDetailView[] {
    return ObjectHelper.toArray(this.relation_section_linked_detail_views)
      .sort();
  }
  constructor() {
    super();
    this.defineProperty('relation_id', null);
    this.defineProperty('edit_relation_selected', null);
    this.defineProperty('link_to_view_selected', null);
    this.defineProperty('is_visible_without_record', false);
    this.defineProperty('linked_detail_view_id', null);
  }

  except = ["linked_detail_view"];

  get defaultLabel(): string {
    return "Relation Section";
  }

  get relation(): object {
    return this.objectModel.allRelations.find(relation => relation.id === this.relation_id);
  }

  createRelationSectionLinkedDetailViews(json: {related_object_model_id: string, detail_view_id: string}) {
    const newRelationSectionLinkedDetailView = this.createEmbeddedObject.relation_section_linked_detail_views(this, json)
    this.initializeEmbedded(this, newRelationSectionLinkedDetailView, 0, {}, false)
  }
}